module.exports = __webpack_public_path__ + "img/noa.88baf5c2.png";